function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmsInbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon material-sms",
    d: "M39 3H7a4 4 0 0 0-3.98 4L3 43l8-8h28a4.012 4.012 0 0 0 4-4V7a4.012 4.012 0 0 0-4-4zM17 21h-4v-4h4zm8 0h-4v-4h4zm8 0h-4v-4h4z",
    transform: "translate(-3 -3)",
    style: {
      fill: "#346ac3"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsInbox);
export default __webpack_public_path__ + "static/media/smsInbox.df01578023ecf942d05972a5221ab540.svg";
export { ForwardRef as ReactComponent };